import { type LucideIcon } from 'lucide-react'
import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * Section heading with a tinted icon chip. Replaces the `SectionHead` helper
 * that was redefined identically across the admin detail views.
 */
interface SectionHeadingProps {
  icon: LucideIcon
  children: ReactNode
  as?: 'h2' | 'h3'
  className?: string
}

export function SectionHeading({
  icon: Icon,
  children,
  as: Tag = 'h2',
  className
}: SectionHeadingProps) {
  return (
    <Tag
      className={cn(
        'mb-4 flex items-center gap-2.5 font-display font-bold tracking-tight text-ink',
        Tag === 'h2' ? 'text-xl' : 'text-base',
        className
      )}
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
        <Icon className="h-5 w-5" />
      </span>
      {children}
    </Tag>
  )
}
